import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Uma linha de "Precisa de você": ícone + título + descrição + ações.
 * Celular: ícone e texto na primeira linha, botões na segunda, em largura cheia.
 */
export function PendenciaItem({
  icone: Icone,
  tom = "atencao",
  titulo,
  descricao,
  acoes,
  testId,
}: {
  icone: LucideIcon;
  tom?: "atencao" | "erro" | "info" | "neutro";
  titulo: React.ReactNode;
  descricao?: React.ReactNode;
  acoes?: React.ReactNode;
  testId?: string;
}) {
  const cor = {
    atencao: "bg-atencao-suave text-atencao",
    erro: "bg-erro-suave text-erro",
    info: "bg-info-suave text-info",
    neutro: "bg-muted text-muted-foreground",
  }[tom];
  return (
    <li className="py-2.5 first:pt-0 last:pb-0 flex flex-col gap-2 md:flex-row md:items-center md:gap-3" data-testid={testId}>
      <div className="flex items-start gap-3 min-w-0 flex-1">
        <span className={cn("h-8 w-8 rounded-md flex items-center justify-center shrink-0", cor)}>
          <Icone className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold leading-snug">{titulo}</p>
          {descricao && <p className="text-xs text-muted-foreground mt-0.5">{descricao}</p>}
        </div>
      </div>
      {acoes && (
        <div className="flex gap-2 md:shrink-0 [&>*]:flex-1 md:[&>*]:flex-none [&>*]:min-h-10 md:[&>*]:min-h-0">
          {acoes}
        </div>
      )}
    </li>
  );
}
